/**
 * Import all module depenencies here.
 * Add commonly used modules to externals.
 */
import core from '../app.core.module.js';
import logoutConfig from './logout.config.js';
import logoutRoute from './logout.route.js';
import logoutController from './logout.controller.js';

/**
 * This is the logout module. It it the entry point for this website.
 * Only declare the module's dependencies in this file.
 * @namespace Logout Module
 */
angular.module('logout', [
  // Shared modules.
  core
])
// Register config.
.config(logoutConfig)
// Register route.
.config(logoutRoute)
// Register controller.
.controller('logoutController', logoutController)

export default 'logout';


// WEBPACK FOOTER //
// ./src/logout/logout.module.js